import { ADDRESS_TYPES, COUNTRIES, PHONE_TYPES, YES_NO_FLAGS, } from '../models/common/addresses';
import { removeNonDigitsFromString } from './general';
export const mapAddressListToCommonModel = (addresses, paginationInfo) => {
    const mappedAddresses = addresses.map((address) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return {
            isDefault: address.isDefault || false,
            companyName: 'companyName' in address ? address.companyName : undefined,
            firstName: ((_a = address.name) === null || _a === void 0 ? void 0 : _a.firstName) || '',
            lastName: ((_b = address.name) === null || _b === void 0 ? void 0 : _b.lastName) || '',
            nickName: address.name && 'nickName' in address.name
                ? address.name.nickName
                : undefined,
            addedBy: 'addedBy' in address ? address.addedBy : undefined,
            primaryPhone: 'phones' in address
                ? ((_d = (_c = address.phones) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.number) || ''
                : ('primaryPhone' in address && ((_e = address.primaryPhone) === null || _e === void 0 ? void 0 : _e.number)) || '',
            alternatePhone: 'phones' in address
                ? (_g = (_f = address.phones) === null || _f === void 0 ? void 0 : _f[1]) === null || _g === void 0 ? void 0 : _g.number
                : ('alternatePhone' in address && ((_h = address.alternatePhone) === null || _h === void 0 ? void 0 : _h.number)) ||
                    '',
            addressLine1: ((_j = address.postalDetails) === null || _j === void 0 ? void 0 : _j.addressLine1) || '',
            addressLine2: (_k = address.postalDetails) === null || _k === void 0 ? void 0 : _k.addressLine2,
            state: ((_l = address.postalDetails) === null || _l === void 0 ? void 0 : _l.state) || '',
            zipCode: ((_m = address.postalDetails) === null || _m === void 0 ? void 0 : _m.zipCode) || '',
            city: ((_o = address.postalDetails) === null || _o === void 0 ? void 0 : _o.city) || '',
            userId: 'userId' in address ? address.userId : undefined,
            lastModifiedDate: address.lastModifiedDate,
            addrIdentifier: address.addrIdentifier,
            instantCheckoutDefault: 'instantCheckoutDefault' in address
                ? address.instantCheckoutDefault
                : undefined,
        };
    });
    return {
        addresses: mappedAddresses,
        paginationInfo: Object.assign(Object.assign({}, (paginationInfo || {})), { addressesOnCurrentPage: addresses.length }),
        response: addresses,
    };
};
export const mapProfileDataToB2CAddAdressRequestModel = (profileData, paymentFormValues, isNoAddresses) => {
    var _a, _b;
    const firstName = ((_a = profileData.account.profile.name) === null || _a === void 0 ? void 0 : _a.firstName) ||
        paymentFormValues.cardHolderName.split(' ')[0];
    const lastName = ((_b = profileData.account.profile.name) === null || _b === void 0 ? void 0 : _b.lastName) ||
        paymentFormValues.cardHolderName.split(' ')[1] ||
        '';
    const primaryPhone = removeNonDigitsFromString(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    paymentFormValues.primaryPhone.number);
    const addressValues = {
        firstName,
        lastName,
        primaryPhone,
        zipCode: paymentFormValues.zipCode,
        isDefault: false,
        addressLine1: paymentFormValues.addressLine1,
        addressLine2: paymentFormValues.addressLine2,
        cityState: paymentFormValues.cityState,
        companyName: '',
        alternatePhone: '',
        nickName: '',
    };
    return mapAddAddressToRequestModel(false, addressValues, isNoAddresses);
};
export const mapAddAddressToRequestModel = (isB2B, addressValues, isNoAddresses) => {
    var _a, _b;
    const { companyName = '', isDefault, nickName, lastName, firstName, addressLine1, zipCode, } = addressValues;
    const cityState = addressValues.cityState.split(',');
    const city = (_a = cityState[0]) === null || _a === void 0 ? void 0 : _a.trim();
    const state = (_b = cityState[1]) === null || _b === void 0 ? void 0 : _b.trim();
    const addressLine2 = addressValues.addressLine2 || undefined;
    const primaryPhone = removeNonDigitsFromString(addressValues.primaryPhone);
    const alternatePhone = addressValues.alternatePhone
        ? removeNonDigitsFromString(addressValues.alternatePhone)
        : undefined;
    if (isB2B) {
        const phones = [
            {
                number: primaryPhone,
                primaryFlag: YES_NO_FLAGS.YES,
                type: PHONE_TYPES.UNKNOWN,
            },
        ];
        if (alternatePhone) {
            phones.push({
                number: alternatePhone,
                type: PHONE_TYPES.UNKNOWN,
                primaryFlag: YES_NO_FLAGS.NO,
            });
        }
        return {
            addressType: ADDRESS_TYPES.SHIPPING,
            companyName,
            isDefault,
            name: {
                firstName,
                lastName,
                nickName,
            },
            phones,
            postalDetails: {
                addressLine1,
                addressLine2,
                city,
                country: COUNTRIES.US,
                state,
                zipCode,
            },
        };
    }
    return {
        isDefault: !!isNoAddresses,
        name: {
            firstName,
            lastName,
        },
        postalDetails: {
            city,
            addressLine1,
            addressLine2,
            state,
            country: COUNTRIES.US,
            zipCode,
        },
        primaryPhone: {
            number: primaryPhone,
        },
        alternatePhone: alternatePhone
            ? {
                number: alternatePhone,
            }
            : undefined,
    };
};
export const mapEditAddressToRequestModel = (isB2B, addressValues, fullAddressData) => {
    var _a, _b, _c, _d, _e;
    const alternatePhone = addressValues.alternatePhone
        ? removeNonDigitsFromString(addressValues.alternatePhone)
        : undefined;
    if (isB2B) {
        const b2bRequestData = mapAddAddressToRequestModel(isB2B, addressValues, false);
        const phones = b2bRequestData.phones.map((phone, ind) => {
            var _a, _b;
            return (Object.assign(Object.assign({}, phone), { id: (_b = (_a = fullAddressData.phones) === null || _a === void 0 ? void 0 : _a[ind]) === null || _b === void 0 ? void 0 : _b.id }));
        });
        if (!alternatePhone && ((_a = fullAddressData.phones) === null || _a === void 0 ? void 0 : _a[1])) {
            phones.push({
                id: (_c = (_b = fullAddressData.phones) === null || _b === void 0 ? void 0 : _b[1]) === null || _c === void 0 ? void 0 : _c.id,
            });
        }
        b2bRequestData.phones = [...phones];
        b2bRequestData.level = fullAddressData.level;
        b2bRequestData.lastModifiedDate = fullAddressData.lastModifiedDate;
        b2bRequestData.addrIdentifier = fullAddressData.addrIdentifier;
        if (fullAddressData.userId) {
            b2bRequestData.userId = fullAddressData.userId;
        }
        return b2bRequestData;
    }
    const b2cRequestData = mapAddAddressToRequestModel(isB2B, addressValues, false);
    b2cRequestData.isDefault = addressValues.isDefault;
    b2cRequestData.primaryPhone.contactMethodEnumeration =
        (_d = fullAddressData.primaryPhone) === null || _d === void 0 ? void 0 : _d.contactMethodEnumeration;
    b2cRequestData.primaryPhone.id = (_e = fullAddressData.primaryPhone) === null || _e === void 0 ? void 0 : _e.id;
    if (fullAddressData.alternatePhone) {
        b2cRequestData.alternatePhone = {
            number: alternatePhone || '',
            id: fullAddressData.alternatePhone.id,
        };
    }
    b2cRequestData.fraudChecked = fullAddressData.fraudChecked;
    b2cRequestData.instantCheckoutDefault =
        fullAddressData.instantCheckoutDefault;
    b2cRequestData.addrIdentifier = fullAddressData.addrIdentifier;
    b2cRequestData.lastModifiedDate = fullAddressData.lastModifiedDate;
    return b2cRequestData;
};
export const mapAddressFormToMappedModal = (address) => {
    const [city, state] = address.cityState.split(', ');
    return {
        isDefault: address.isDefault || false,
        companyName: address.companyName || '',
        primaryPhone: address.primaryPhone || '',
        alternatePhone: address.alternatePhone || '',
        firstName: address.firstName || '',
        lastName: address.lastName || '',
        nickName: address.nickName || '',
        zipCode: address.zipCode || '',
        addressLine1: address.addressLine1 || '',
        addressLine2: address.addressLine2 || '',
        city,
        state,
    };
};
export const mapB2CPaymentAddressToFormModel = (address, paymentValues) => {
    var _a, _b;
    return ({
        isDefault: !!(address === null || address === void 0 ? void 0 : address.isDefault),
        addressLine1: paymentValues.addressLine1,
        addressLine2: paymentValues.addressLine2,
        companyName: '',
        firstName: address.name.firstName,
        lastName: address.name.lastName,
        nickName: '',
        primaryPhone: ((_a = paymentValues.primaryPhone) === null || _a === void 0 ? void 0 : _a.number) || '',
        alternatePhone: (_b = address.alternatePhone) === null || _b === void 0 ? void 0 : _b.number,
        zipCode: paymentValues.zipCode,
        cityState: paymentValues.cityState,
    });
};
export const mapB2CPaymentAddressToRequestModel = (address, paymentValues) => {
    const addressValues = mapB2CPaymentAddressToFormModel(address, paymentValues);
    return mapEditAddressToRequestModel(false, addressValues, address);
};
